// extracted by mini-css-extract-plugin
export default {"icon":"primary-link-button-styles__icon","primaryButton":"primary-link-button-styles__primaryButton"};